import { useEffect } from 'react'

export const TestErrorComponent = () => {
  useEffect(() => {
    const isLocalOrDev = import.meta.env.MODE === 'development' || import.meta.env.MODE === 'local'

    if (isLocalOrDev && window.location.search.includes('test-error')) {
      throw new Error('Test error for production Error Boundary')
    }
  }, [])

  return null
}
